module.exports = __webpack_public_path__ + "img/central-community.fb158702.jpg";